import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";
import * as dayjs from "dayjs";
dayjs().format();

export const fectchBiens = (payload) => async (dispatch) => {
  console.log("fectchBiens avec statistique nbre", payload);
  try {
    const response = await instance.get("bienAdmin");
    if (response["status"] === 200) {
      const biensFilter = response?.data.data.filter((item) => {
        return dayjs(item.created_at).format("YYYY") == payload.$y;
      });
      console.log("fectchBiens", {
        one: payload.$y,
        two: biensFilter,
      });
      dispatch(
        fetchBiensFulfilled({
          dataDisponible: biensFilter.filter(
            (item) => item.statut === "Disponible"
          ),
          dataIndisponible: biensFilter.filter(
            (item) => item.statut === "Indisponible"
          ),
          dataVendus: biensFilter.filter((item) => item.statut === "Vendu"),
          dataLouer: biensFilter.filter((item) => item.statut === "Louer"),
        })
      );
    }
  } catch (error) {
    console.log();
  }
};
// export const removeFlagCommandes = (payload) => async (dispatch) => {
//   try {
//     const response = await instance.post("/updateFlagCommande/" + payload);
//     console.log("REPONSEBIENS", response);
//     if (response.status === true) {
//       dispatch(removeItem());
//     }
//   } catch (error) {
//     console.log();
//   }
// };
export const biensReducer = createSlice({
  name: "Biens",
  initialState: {
    Biens: [],
    totalBiens: null,
    totalBiensIndisponible: null,
    totalBiensVendus: null,
    totalBiensLouer: null,
  },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.commande_length - 1;
      return { ...state, commande_length: nouveau_length };
    },
    fetchBiensFulfilled: (state, action) => {
      return {
        ...state,
        Biens: action.payload,
        totalBiens: action.payload.dataDisponible.length,
        totalBiensIndisponible: action.payload.dataIndisponible.length,
        totalBiensVendus: action.payload.dataVendus.length,
        totalBiensLouer: action.payload.dataLouer.length,
      };
    },
  },
});

export const { handleTotalNew, fetchBiensFulfilled, removeItem } =
  biensReducer.actions;
export default biensReducer.reducer;
